import React, { useState, useEffect } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import {
  EditBrandByAPI,
  GetBrandById,
  GetProductStatus,
  GetPincodeProduct,
} from "../apiconfig/authService";

function EditBrand(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const [editedEmployeeData, setEditedEmployeeData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [product, setProduct] = useState([]);
  const setProductViewMessage = props.setMessage;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await GetBrandById(
          id,
          localStorage.getItem("accessToken")
        );
        setEditedEmployeeData(response.data);
      } catch (error) {
        setMessage("Failed to fetch brand data.");
        setIsMessageRed(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );

        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleDescriptionChange = (e) => {
    setEditedEmployeeData((prevData) => ({
      ...prevData,
      brandname: e.target.value,
    }));
  };

  const handleStatusIdChange = (e) => {
    setEditedEmployeeData((prevData) => ({
      ...prevData,
      statusid: Number(e.target.value), // Update statusid in editedEmployeeData
    }));
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    if (!editedEmployeeData.brandname) {
      setMessage("Brand name is required");
      setIsMessageRed(true);
      return;
    }

    try {
      const response = await EditBrandByAPI(
        {
          id: id,
          brandname: editedEmployeeData.brandname,
          statusid: editedEmployeeData.statusid,
        },
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setProductViewMessage(response.data.message);
        setIsMessageRed(false);
        navigate("/brand");
      }
    } catch (err) {
      setMessage(
        err.response?.data?.error || "An error occurred. Please try again."
      );
      setIsMessageRed(true);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Brand Name</h1>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "green" }}
            className="alert alert-primary"
          >
            {message}
          </div>
        )}

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <form onSubmit={handleSubmitClick}>
            <div className="personal-info tab-pane active storetab mb-3">
              <div className="form-group col-sm-12 col-lg-12">
                <label htmlFor="brandName">Brand Name</label>
                <input
                  type="text"
                  onChange={handleDescriptionChange}
                  value={editedEmployeeData.brandname || ""}
                  className="form-control custom-input my-3"
                  id="brandname"
                  placeholder="Brand Name"
                />
              </div>
              <div className="form-group col-sm-12 col-lg-12 mb-3">
                <label htmlFor="floatingInput">Status</label>
                <select
                  className="form-select custom-input my-2"
                  onChange={handleStatusIdChange}
                  value={editedEmployeeData.statusid || ""}
                >
                  {statusData?.map((item) => (
                    <option key={item.statusid} value={item.statusid}>
                      {item.status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-sm-12 col-lg-12 mb-3 ">
                <button
                  type="submit"
                  className="btn btn-primary save-btn text-uppercase px-4 my-3"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default EditBrand;
